import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const NotSelectIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "NotSelectGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.0005 21.999C6.48633 21.999 2 17.5127 2 11.999C2 6.48535 6.48633 2 12.0005 2C14.687 2 17.2085 3.05566 19.105 4.97363C19.1274 4.99218 19.1489 5.01074 19.1665 5.03027C19.1797 5.04492 19.1943 5.06347 19.208 5.083C21.0093 6.95898 22.0005 9.41308 22.0005 11.999C22.0005 17.5127 17.5147 21.999 12.0005 21.999ZM12.0005 3C7.0376 3 3 7.03711 3 11.999C3 16.9619 7.0376 20.999 12.0005 20.999C16.9629 20.999 21.0005 16.9619 21.0005 11.999C21.0005 9.66015 20.0982 7.43945 18.4595 5.74707C18.4507 5.7373 18.4414 5.72754 18.4321 5.71582C18.4297 5.71387 18.4277 5.71094 18.4253 5.70898C16.7114 3.96093 14.4312 3 12.0005 3ZM12.0005 19.3984C10.5645 19.3984 9.16748 18.9805 7.95947 18.1895C7.83349 18.1074 7.75146 17.9727 7.73584 17.8232C7.7207 17.6729 7.77344 17.5244 7.87988 17.418L17.4194 7.87892C17.5259 7.7715 17.6738 7.71779 17.8242 7.73537C17.9741 7.75099 18.1089 7.83303 18.1914 7.959C18.9814 9.16603 19.3989 10.5625 19.3989 11.999C19.3989 16.0791 16.0801 19.3984 12.0005 19.3984ZM9.04346 17.6689C9.95606 18.1475 10.9668 18.3984 12.0005 18.3984C15.5288 18.3984 18.3989 15.5274 18.3989 11.999C18.3989 10.9649 18.1484 9.95508 17.6699 9.04298L9.04346 17.6689ZM6.36328 16.4639C6.34912 16.4639 6.33496 16.4629 6.32031 16.4619C6.17334 16.4492 6.03955 16.3731 5.95459 16.252C5.06934 14.9971 4.60156 13.5264 4.60156 11.999C4.60156 7.91993 7.9209 4.60059 12.0005 4.60059C13.5274 4.60059 14.9981 5.06836 16.2524 5.95411C16.3731 6.03907 16.4497 6.17286 16.4624 6.31934C16.4751 6.4668 16.4224 6.61133 16.3179 6.71582L6.7168 16.3174C6.62256 16.4111 6.49512 16.4639 6.36328 16.4639ZM12.0005 5.60059C8.47217 5.60059 5.60156 8.47071 5.60156 11.999C5.60156 13.1192 5.89306 14.2041 6.44922 15.1709L15.1714 6.44824C14.2051 5.8916 13.1201 5.60059 12.0005 5.60059Z"
        fill="#777677"
      />
    </svg>
  );
};

export default NotSelectIcon;
